import { render, staticRenderFns } from "./resources-page.vue?vue&type=template&id=707d716a"
import script from "./resources-page.vue?vue&type=script&lang=js"
export * from "./resources-page.vue?vue&type=script&lang=js"
import style0 from "./resources-page.vue?vue&type=style&index=0&id=707d716a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports